import { render, staticRenderFns } from "./AppNavItem.vue?vue&type=template&id=caf70c3a&scoped=true&"
import script from "./AppNavItem.vue?vue&type=script&lang=ts&"
export * from "./AppNavItem.vue?vue&type=script&lang=ts&"
import style0 from "./AppNavItem.vue?vue&type=style&index=0&id=caf70c3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf70c3a",
  null
  
)

export default component.exports